import React, { FC } from "react";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";
import Footer from "../src/components/Footer/Footer";
import Register from "../src/pages/Register/Register";
import { RegisterProvider } from "../src/contexts/RegisterContext";
import { useColorModeContext } from "../src/contexts/CustomThemeProvider";


interface RegisterPageProps extends WithRouterProps {
}

const RegisterPage: FC<RegisterPageProps> = ({ router }) => {
  const seoTitle = "Register | That's The Ticket";

  const { setColorMode } = useColorModeContext();
  setColorMode("dark");

  const step = Number(router.query.step);
  const email = router.query.email as string;
  const firstName = router.query.firstName as string;

  return (
    <>
      <Head>
        <title>{`${seoTitle}`}</title>
        <meta key="ogTitle" property="og:title" content={seoTitle} />
        <meta key="twitterTitle" name="twitter:title" content={seoTitle} />
      </Head>

      <RegisterProvider>
        <Register currentStep={step} email={email} firstName={firstName} />
      </RegisterProvider>

      <Footer />
    </>

  );
}

export default withRouter(RegisterPage);

export const getServerSideProps: GetServerSideProps = async ({ params }: GetServerSidePropsContext) => {

  return {
    props: {}
  }
}